export const BATTLE_PASS_ANALYTIC_EVENTS = {
    BADGE_CLICK: 'battle_pass_badge_click',
    DROP_CHANGE: 'battle_pass_drop_change',
    SEE_MORE: 'battle_pass_see_more',
};
